import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';
import Slider from 'react-slick';

import Color from '@tool/color';

interface IProps {
  list: any[],
}
interface IState {}

const AdSlick = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { list } = props;

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <Slider {...{
      dots: false,
      infinite: true,
      autoplaySpeed: 3000,
      // speed: 500,
      arrows: false,
      autoplay: true,
      // slidesToShow: length,
    }}>
      {list && list.map((item, index) => (
        <img key={index} src={item.imageUrl} alt="img"
          onClick={() => { window.location.href = item.toUrl; }} />
      ))}
    </Slider>
  );
};

export default observer(AdSlick);
